import { cards } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '悬疑': 'bg-accent-100 text-accent-700',
  '科幻': 'bg-primary-100 text-primary-700',
  '古装': 'bg-secondary-100 text-secondary-800',
  '喜剧': 'bg-primary-100 text-primary-700',
  '动漫': 'bg-accent-100 text-accent-700',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队精心甄选的高分影视佳作，好片不踩雷
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.target as HTMLImageElement;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${tagColors[card.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                    {card.tag}
                  </span>
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-background-50/80 backdrop-blur-sm text-foreground-700">
                    {card.year}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-background-50/80 backdrop-blur-sm">
                  <i className="ri-star-fill text-xs text-primary-500"></i>
                  <span className="text-xs font-bold text-foreground-900">{card.rating}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}